/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/profile/profile-wall.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.PROFILE_BUSINESS_WALL,
    path: 'social-network/profile/:profileId/wall',
    props: { context: 'SOCIAL_NETWORK.LABEL.SOCIAL_NETWORK_PAGE' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/profile/profile-wall.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.PROFILE_WALL,
    path: 'social-network/profile/wall',
    props: { context: 'SOCIAL_NETWORK.LABEL.SOCIAL_NETWORK_PAGE' }
  },
  // Dummy live route only for side menu.
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/profile/profile-wall.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.LIVE.HOME,
    path: 'live',
    props: { context: 'SOCIAL_NETWORK.LABEL.SOCIAL_NETWORK_PAGE' }
  },
  // Dummy live route only for side menu.
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/profile/profile-wall.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.CLUB.HOME,
    path: 'club',
    props: { context: 'SOCIAL_NETWORK.LABEL.SOCIAL_NETWORK_PAGE' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/profile/profile-form.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.PROFILE_CREATE,
    path: 'social-network/profile/create',
    props: {
      context: 'SOCIAL_NETWORK.LABEL.CREATE_PROFILE',
      isCreating: true
    }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/profile/profile-waiting-approval.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.PROFILE_WAITING_APPROVAL,
    path: 'social-network/profile/waiting-approval',
    props: { context: 'SOCIAL_NETWORK.LABEL.PROFILE_STATUS' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/profile/profile-form.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.PROFILE_UPDATE,
    path: 'social-network/profile/update',
    props: {
      context: 'SOCIAL_NETWORK.LABEL.YOUR_PROFILE',
      isEditing: true
    }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/post/post-detail.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.POST_DETAIL,
    path: 'social-network/profile/posts/:id/detail',
    props: { context: 'SOCIAL_NETWORK.LABEL.POST' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/post/post-products.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.POST_PRODUCTS,
    path: 'social-network/profile/posts/:id/products',
    props: { context: 'SOCIAL_NETWORK.LABEL.POST_PRODUCTS' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/comment/comment-list.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.POST_COMMENTS,
    path: 'social-network/profile/posts/:id/comments',
    props: { context: 'SOCIAL_NETWORK.LABEL.POST_COMMENTS' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/comment/comment-questions.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.COMMENT_QUESTIONS,
    path: 'social-network/profile/comments/questions',
    props: { context: 'SOCIAL_NETWORK.LABEL.SOCIAL_NETWORK_PAGE' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/comment/comment-reply-form.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.COMMENT_QUESTION_REPLY,
    path: 'social-network/profile/comments/:id/reply',
    props: { context: 'SOCIAL_NETWORK.LABEL.QUESTION_REPLY' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/post/post-form.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.POST_CREATE,
    path: 'social-network/profile/posts/create',
    props: {
      context: 'SOCIAL_NETWORK.LABEL.NEW_POST',
      isCreating: true
    }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/post/post-form.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.POST_UPDATE,
    path: 'social-network/profile/posts/:id/update',
    props: {
      context: 'SOCIAL_NETWORK.LABEL.UPDATE_POST',
      isEditing: true
    }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/statistics/dashboard.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.STATISTICS_DASHBOARD,
    path: 'social-network/statistics/dashboard',
    props: { context: 'SOCIAL_NETWORK.LABEL.SOCIAL_NETWORK_PAGE' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/statistics/profile-report.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.STATISTICS_PROFILE,
    path: 'social-network/statistics/profile/report',
    props: { context: 'SOCIAL_NETWORK.LABEL.STATISTICS_PROFILE' }
  },
  {
    component: () =>
      import(

        /* webpackChunkName: "socialNetwork" */
        '@/modules/social-network/scenes/statistics/post-report.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.SOCIAL_NETWORK.STATISTICS_POST,
    path: 'social-network/statistics/post/:id/report',
    props: { context: 'SOCIAL_NETWORK.LABEL.STATISTICS_POST' }
  }
] as RouteConfig[];
